import * as Yup from 'yup';

export const editSireReviewReviewerSchema = (version: string, dataDetail: any) => {
    return (
        Yup.object({
            vesselType: Yup.string()
                .trim()
                .required('Vessel type is required'),
            sireReviewVersion: Yup.string()
                .trim()
                .required('SIRE review version is required'),
            OCIMFSireReportV1Status: version === '0' && dataDetail?.ocimfSireReportId ? Yup.string()
                .trim()
                .required('OCIMF SIRE report status is required') : Yup.string().nullable(),
            OCIMFSireReportV1Review: version === '0' && dataDetail?.ocimfSireReportId ? Yup.string()
                .trim()
                .required('OCIMF SIRE report review is required') : Yup.string().nullable(),
            OfficerMatrixStatusV1: dataDetail?.officerMatrixId ? Yup.string()
                .trim()
                .required('OCIMF matrix status is required') : Yup.string().nullable(),
            OfficerMatrixReviewV1: dataDetail?.officerMatrixId ? Yup.string()
                .trim()
                .required('OCIMF matrix review is required') : Yup.string().nullable(),
            // ClassSurveyStatusStatusV1: dataDetail?.classSurveyStatusId ? Yup.string()
            //     .trim()
            //     .required('Class survey status is required') : Yup.string().nullable(),
            // ClassSurveyStatusReviewV1: dataDetail?.classSurveyStatusId ? Yup.string()
            //     .trim()
            //     .required('Class survey review is required') : Yup.string().nullable(),
            // CAPSurveyReportStatusV1: dataDetail?.capSurveyReportId ? Yup.string()
            //     .trim()
            //     .required('CAP/CAS survey report status is required') : Yup.string().nullable(),
            // CAPSurveyReportReviewV1: dataDetail?.capSurveyReportId ? Yup.string()
            //     .trim()
            //     .required('CAP/CAS survey report review is required') : Yup.string().nullable(),
            ClassSurveyStatusStatusV1: Yup.string()
                .trim()
                .required('Class survey status is required'),
            ClassSurveyStatusReviewV1: Yup.string()
                .trim()
                .required('Class survey review is required'),
            CAPSurveyReportStatusV1: Yup.string()
                .trim()
                .required('CAP/CAS survey report status is required'),
            CAPSurveyReportReviewV1: Yup.string()
                .trim()
                .required('CAP/CAS survey report review is required'),
            OCIMFSireReportV2HardwareStatus: (version === '1' && dataDetail?.ocimfSireReportId) ? Yup.string()
                .trim()
                .required('OCIMF SIRE report hardware status is required') : Yup.string().nullable(),
            OCIMFSireReportV2HardwareRectifiedStatus: (version === '1' && dataDetail?.ocimfSireReportId) ? Yup.string()
                .trim()
                .required('OCIMF SIRE report hardware status is required') : Yup.string().nullable(),
            OCIMFSireReportV2ProcessStatus: (version === '1' && dataDetail?.ocimfSireReportId) ? Yup.string()
                .trim()
                .required('OCIMF SIRE report process status is required') : Yup.string().nullable(),
            OCIMFSireReportV2ProcessRectifiedStatus: (version === '1' && dataDetail?.ocimfSireReportId) ? Yup.string()
                .trim()
                .required('OCIMF SIRE report process rectified status is required') : Yup.string().nullable(),
            OCIMFSireReportV2HumanStatus: (version === '1' && dataDetail?.ocimfSireReportId) ? Yup.string()
                .trim()
                .required('OCIMF SIRE report human status is required') : Yup.string().nullable(),
            OCIMFSireReportV2HumanRectifiedStatus: (version === '1' && dataDetail?.ocimfSireReportId) ? Yup.string()
                .trim()
                .required('OCIMF SIRE report human rectified status is required') : Yup.string().nullable(),
            OCIMFSireReportV2PhotographStatus: (version === '1' && dataDetail?.ocimfSireReportId) ? Yup.string()
                .trim()
                .required('OCIMF SIRE report photograph status is required') : Yup.string().nullable(),
            OCIMFSireReportV2PhotographRectifiedStatus: (version === '1' && dataDetail?.ocimfSireReportId) ? Yup.string()
                .trim()
                .required('OCIMF SIRE report photograph rectified status is required') : Yup.string().nullable(),
            AllStatutoryCertificatesStatusV1: Yup.string()
                .trim()
                .required('All statutory certification status is required'),
            AllStatutoryCertificatesReviewV1: Yup.string()
                .trim()
                .required('All statutory certification review status is required'),
            OthersStatus: dataDetail?.othersId ? Yup.string()
                .trim()
                .required('Other status is required') : Yup.string().nullable(),
            OthersReview: dataDetail?.othersId ? Yup.string()
                .trim()
                .required('Other review is required') : Yup.string().nullable(),
            OCIMFSireReportV1Date: Yup.date()
                .typeError('OCIMF sire report date must be a valid date')
                .required('OCIMF sire report date is required'),
            OfficerMatrixV1Date: Yup.date()
                .typeError('Officer matrix date must be a valid date')
                .required('Officer matrix date is required'),
        }));
}
